import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
 DropdownMenu,
 DropdownMenuContent,
 DropdownMenuItem,
 DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useTheme } from '@/providers/ThemeProvider';

export function ThemeToggle() {
 const { setTheme } = useTheme();

 return (
  <DropdownMenu>
   <DropdownMenuTrigger asChild>
    <Button variant='ghost' size='icon' className='rounded-none h-10 w-10'>
     <Sun className='h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0' />
     <Moon className='absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100' />
     <span className='sr-only'>Toggle theme</span>
    </Button>
   </DropdownMenuTrigger>
   <DropdownMenuContent align='end' className='rounded-none'>
    <DropdownMenuItem
     onClick={() => setTheme('light')}
     className='rounded-none font-mono text-xs'
    >
     Light
    </DropdownMenuItem>
    <DropdownMenuItem
     onClick={() => setTheme('dark')}
     className='rounded-none font-mono text-xs'
    >
     Dark
    </DropdownMenuItem>
    <DropdownMenuItem
     onClick={() => setTheme('system')}
     className='rounded-none font-mono text-xs'
    >
     System
    </DropdownMenuItem>
   </DropdownMenuContent>
  </DropdownMenu>
 );
}
